import i18n from '../i18n';

const LOCALE_MAP = {
  en: 'en-US',
  fr: 'fr-FR',
  ar: 'ar-SA',
};

export const getFormattingLocale = () => {
  return LOCALE_MAP[i18n.language] || 'en-US';
};

export const formatDate = (dateString, options = {}) => {
  if (!dateString) return '';
  const defaultOptions = { year: 'numeric', month: 'short', day: 'numeric' };
  return new Date(dateString).toLocaleDateString(
    getFormattingLocale(),
    { ...defaultOptions, ...options }
  );
};

export const formatDateTime = (dateString, options = {}) => {
  if (!dateString) return '';
  const defaultOptions = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' };
  return new Date(dateString).toLocaleString(
    getFormattingLocale(),
    { ...defaultOptions, ...options }
  );
};

export const formatNumber = (num) => {
  if (num === null || num === undefined) return '';
  return new Intl.NumberFormat(getFormattingLocale()).format(num);
};

export const formatRelativeTime = (dateStr) => {
  if (!dateStr) return '';
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return i18n.t('common:notifications.justNow');
  if (mins < 60) return i18n.t('common:notifications.minutesAgo', { count: mins });
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return i18n.t('common:notifications.hoursAgo', { count: hrs });
  const days = Math.floor(hrs / 24);
  return i18n.t('common:notifications.daysAgo', { count: days });
};
